import { ReactNode } from 'react';
import { AppProvider } from './AppProvider';

const ContextProviders = ({ children }: { children: ReactNode }) => {
  return <AppProvider>{children}</AppProvider>;
};

export default ContextProviders;
